var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('settings-header'),_c('preferences',{attrs:{"tasks-setting":_vm.tasksSetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }